import BaseComponent from './BaseComponent';

class GuidancePage extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;

        this.el.querySelectorAll('.accordion__subitem a, .text-element a').forEach((accordion) => {
            accordion.addEventListener('click', (e) => {
                if (!accordion.href) {
                    return;
                }
                const isInternalURL = new URL(accordion.href).origin == location.origin;
                if (isInternalURL && accordion.href.split('/').pop().indexOf('.') > 0) {
                    e.preventDefault();
                    window.location.hash = '#filebank';
                    this.handleOverlay(this.el.dataset.uri + accordion.href);
                }
            });
        });
        

        this.el.querySelectorAll('.accordion__subitem__file').forEach((accordion) => {
            accordion.addEventListener('click', (e) => {
                this.handleOverlay(accordion.dataset.href);
            });
        });

        this.el.querySelectorAll('.print-section').forEach((section) => {
            section.addEventListener('click', (e) => {
                this.el.querySelectorAll('.accordion__item').forEach((item) => {
                    if (item.dataset.toggle == e.target.dataset.number) {
                        item.classList.add('accordion-item-print-shown');
                        item.classList.remove('accordion-item-print-hidden');
                        return;
                    }
                    item.classList.remove('accordion-item-print-shown');
                    item.classList.add('accordion-item-print-hidden');
                });
                window.print();
            });
        });
    }


    handleOverlay(url) {
        const modalSelector = document.querySelector('#filebank .modal__body');
        modalSelector.innerHTML = '';
        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                }
                return Promise.reject(response);
            })
            .then(function (html) {
                const div = document.createElement('div');
                div.innerHTML = html;
                modalSelector.innerHTML = div.querySelector('.file-download').outerHTML;
            })
            .catch(function (error) {
                console.warn(error);
            });
    }
}

export default GuidancePage;
